const ActionTypes = {
  start: 'start',
  find: 'find',
  findOne: 'findOne',
  create: 'create',
  upload: 'upload',
  update: 'update',
  update_many: 'update_many',
  delete: 'delete',
  delete_many: 'delete_many',
  error: 'error',
  clear: 'clear',
};

export default ActionTypes;
